import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'Common/Components/Checkbox';

/**
 * "Select all" header checkbox, with the partial state for when only some rows are selected.
 * Presentational only: the view computes `checked`/`indeterminate` and handles `onChange`.
 */
const SelectionHeader = ({ checked = undefined, indeterminate = undefined, onChange = undefined, disabled = undefined }) => (
  <Checkbox theme="grey" state={ checked } partialChecked={ indeterminate } onChange={ onChange } disabled={ disabled } />
);

SelectionHeader.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default SelectionHeader;
